import { AppliedFacets } from './applied-facets';
import { FilterItem } from '../../shared/models/filter';

export class CombinedExpandState {
    constructor(
        public customerId: string,
        public nextRequestId?: any,
        public facets?: AppliedFacets,
        public pageId?: string,
        public onlyInStock?: boolean,
        public nextPage?: number,
        public searchTerm?: string,
        public filterItems?: FilterItem[]
    ) {}

    get valueKey(): string {
        return `${this.pageId} - ${this.nextRequestId} - ${this.onlyInStock} - ${Object.keys(this.facets).reduce(
            (prev, curr) => `${curr}=(${this.facets[curr].join('|')})`,
            ''
        )}`
    }
}
